<button type="button" #notificationsDrawerButton command="show-modal" commandfor="notificationsDrawer"
    class="relative rounded-full p-1 text-secondary hover:text-primary focus:outline-2 focus:outline-offset-2 focus:outline-primary hover:cursor-pointer">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 sm:size-6">
        <path d="M10.268 21a2 2 0 0 0 3.464 0" />
        <path
            d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
    </svg>
</button>

<el-dialog>
    <dialog #notificationsDrawerDialog id="notificationsDrawer" aria-labelledby="notificationsDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20" (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-border">

                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary">
                                        Notifications
                                    </p>
                                    <p class="text-sm text-secondary">
                                        You'll be notified about important updates here.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-border">

                            <div class="h-full overflow-y-auto scrollbar-transparent">

                                <!-- Top Filters -->
                                <div
                                    class="shrink-0 flex flex-row items-center justify-between px-2 py-2 border-b border-border">
                                    <nav aria-label="Tabs" class="flex space-x-4">
                                        <a (click)="switchToUnread('all')"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getTabClass('all')">All</a>
                                        <a (click)="switchToUnread('unread')"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getTabClass('unread')">Unread</a>
                                    </nav>

                                    <button type="button" (click)="markAllAsRead()" class="btn-fab-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
                                            <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
                                        </svg>
                                    </button>

                                </div>
                                <!-- Top Filters - END -->

                                <!-- Notification List -->
                                <div class="flex-1 flex flex-col">
                                    @if (displayNotifications() && displayNotifications()!.length > 0) {
                                    <div>
                                        <ul role="list" class="divide-y divide-border">
                                            @for (notification of displayNotifications(); track $index) {
                                            <li class="flex items-center justify-between gap-x-6 py-3 px-2"
                                                [class]="getReadUnreadClass(notification.read)">
                                                <div class="flex min-w-0 gap-x-4">

                                                    <div class="h-12 w-12 bg-muted rounded-full">
                                                        <atom-ldg-img class="w-12 h-12"
                                                            [src]="imageService.getImageSource(notification.image, 'gallery')"
                                                            inputClass="flex-none rounded-md bg-card" h="12" w="12"
                                                            radius="full"></atom-ldg-img>
                                                    </div>
                                                    <div class="min-w-0 flex-auto">
                                                        <p class="text-sm font-semibold leading-6 text-primary">{{
                                                            notification.title }}</p>
                                                        <p class="mt-1 truncate text-xs leading-5 text-secondary">{{
                                                            notification.content }}</p>
                                                        <p class="mt-1 truncate text-xs leading-5 text-secondary">{{
                                                            notification.createdDate | date : "dd MMM HH:mm" }}</p>
                                                    </div>
                                                </div>
                                                <a (click)="openNotification(notification)"
                                                    class="rounded-full bg-card px-2.5 py-1 text-xs font-semibold text-primary shadow-sm ring-1 ring-inset ring-border hover:bg-muted cursor-pointer">View</a>
                                            </li>
                                            }
                                        </ul>
                                    </div>
                                    } @else if (displayNotifications() && displayNotifications()!.length == 0) {
                                    <div class="flex flex-col items-center justify-center w-full h-full py-12">
                                        <div class="text-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="mx-auto size-12 text-secondary">
                                                <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                                                <path
                                                    d="M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742" />
                                                <path d="m2 2 20 20" />
                                                <path d="M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-primary">No Notifications</h3>
                                            <p class="mt-1 text-sm text-secondary">You'll be notified about important
                                                updates here.</p>
                                        </div>

                                    </div>
                                    } @else {
                                    <div class="flex flex-col items-center justify-center w-full h-full">
                                        <atom-loading-inline title="Loading Notifications"
                                            message="Loading notifications..."></atom-loading-inline>
                                    </div>
                                    }
                                </div>
                                <!-- Notification List - END -->
                            </div>

                        </div>
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>